import { makeAutoObservable } from 'mobx';

import { RootStore } from './';

type SearchParams = {
  description?: string;
  createdDate?: string;
  violationDateStart?: string;
  violationDateEnd?: string;
  violationId?: string;
};
export class ViolationsStore {
  private _list: Violation[];
  private _limit = 20;
  private _showLoader = false;
  private _hasMoreResults = true;
  private _nextLink = '';
  // private _equipmentSelectedList: Array<any> = [];
  private _sortBy = '';
  private _sortDirection = '';
  private _description = '';
  private _createdDate = '';
  private _violationDateStart = '';
  private _violationDateEnd = '';
  private _violationId = '';

  constructor(public rootStore: RootStore) {
    this._list = [];
    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  setShowLoader(value: boolean) {
    this._showLoader = value;
  }

  setNextLink(link: string) {
    this._nextLink = link;
  }

  setHasMoreResults(hasMoreResults: boolean) {
    this._hasMoreResults = hasMoreResults;
  }

  setSortBy(data: string) {
    this._sortBy = data;
  }

  setSortDirection(data: string) {
    this._sortDirection = data;
  }

  resetSortParams() {
    this._sortBy = '';
    this._sortDirection = '';
  }
  resetSearchParams() {
    this._createdDate = '';
    this._description = '';
    this._violationDateStart = '';
    this._violationDateEnd = '';
    this._violationId = '';
  }
  setSearchParams(data: string | SearchParams) {
    if (typeof data === 'string') {
      this._description = data;
      this._createdDate = '';
      return;
    }

    this._createdDate = data.createdDate || '';
    this._description = data.description || '';
    this._violationDateStart = data.violationDateStart || '';
    this._violationDateEnd = data.violationDateEnd || '';
  }

  setSearchParamsViolationId(data: string) {
    this._violationId = data;
  }

  get Data() {
    return this._list;
  }

  get NextLink() {
    return this._nextLink;
  }

  get HasMoreResults() {
    return this._hasMoreResults;
  }

  get SortBy() {
    return this._sortBy;
  }

  get SortDirection() {
    return this._sortDirection;
  }

  get ShowLoader() {
    return this._showLoader;
  }

  get SearchParams() {
    return {
      createdDate: this._createdDate,
      description: this._description,
      violationDateEnd: this._violationDateEnd,
      violationDateStart: this._violationDateStart,
    };
  }

  resetParams() {
    this._nextLink = '';
    this._list = [];
  }

  getList = async (searchParams: SearchParams = {}) => {
    const {
      createdDate = '',
      description = '',
      violationDateEnd = '',
      violationDateStart = '',
      violationId = '',
    } = searchParams;
    this._createdDate = createdDate || this._createdDate;
    this._description = description || this._description;
    this._violationDateEnd = violationDateEnd || this._violationDateEnd;
    this._violationDateStart = violationDateStart || this._violationDateStart;
    this._violationId = violationId || this._violationId;
    const params = {
      ...(this._limit ? { limit: this._limit } : {}),
      ...(this._sortBy ? { sortBy: this._sortBy } : {}),
      ...(this._sortDirection ? { sortDirection: this._sortDirection } : {}),
      ...(this._nextLink ? { nextLink: this._nextLink } : {}),
      ...(this._createdDate ? { createdDate: this._createdDate } : {}),
      ...(this._description ? { description: this._description } : {}),
      ...(this._violationDateStart
        ? { violationDateStart: this._violationDateStart }
        : {}),
      ...(this._violationDateEnd
        ? { violationDateEnd: this._violationDateEnd }
        : {}),
      ...(this._violationId ? { violationId: this._violationId } : {}),
    };
    const { list, nextLink } =
      await this.rootStore.apiStore.violationsApi.getData(params);
    this._list = [...this._list, ...list];
    if (nextLink === this._nextLink || list.length < this._limit) {
      this._nextLink = '';
    } else {
      this._nextLink = nextLink;
    }
  };

  getMoreDetailsByViolationId = (id: string) =>
    this.rootStore.apiStore.violationsApi.getMoreDetails(id);

  exportList = async (searchParams: SearchParams = {}) => {
    const {
      createdDate = '',
      description = '',
      violationDateEnd = '',
      violationDateStart = '',
    } = searchParams;
    this._createdDate = createdDate || this._createdDate;
    this._description = description || this._description;
    this._violationDateEnd = violationDateEnd || this._violationDateEnd;
    this._violationDateStart = violationDateStart || this._violationDateStart;
    const params = {
      ...(this._sortBy ? { sortBy: this._sortBy } : {}),
      ...(this._sortDirection ? { sortDirection: this._sortDirection } : {}),
      ...(this._createdDate ? { createdDate: this._createdDate } : {}),
      ...(this._description ? { description: this._description } : {}),
      ...(this._violationDateStart
        ? { violationDateStart: this._violationDateStart }
        : {}),
      ...(this._violationDateEnd
        ? { violationDateEnd: this._violationDateEnd }
        : {}),
    };
    return await this.rootStore.apiStore.violationsApi.export(params);
  };
}
